import {
  MANAGECHALLENGES_SINGLE,
  MANAGECHALLENGES_RECURRING,
  MANAGECHALLENGES_TAB_SELECTED,
  MANAGECHALLENGES_SINGE_LIST,
  MANAGECHALLENGES_RECURRING_LIST,
  LOAD_EDIT_CHALLENGES_DATA,
  OPEN_CHALLENGES_MODAL,
  MANAGECHALLENGES_MAX_DISPLAYORDER,
  MANAGECHALLENGES_HTML_TEMPLATE,
} from "ManagechallengesActions";

export var ManagechallengesMenu = (state = [], action) => {
  //iconName is optional
  var state = [
    {
      key: MANAGECHALLENGES_SINGLE,
      iconName: "singechallenge",
      sectionName: "Single Challenge",
      sectionDesc: "Description of Single Challenge",
      selected: false,
    },
    {
      key: MANAGECHALLENGES_RECURRING,
      iconName: "recurringchallenge",
      sectionName: "Recurring Challenge",
      sectionDesc: "Description of Recurring Challenge",
      selected: false,
    },
  ];

  var index = 0;
  state[index].selected = true;

  return state;
};

// Initial select tab is "MANAGECHALLENGES_TAB_SELECTED"
export var ManagechallengesSelectedTab = (
  state = MANAGECHALLENGES_SINGLE,
  action
) => {
  if (action.type == MANAGECHALLENGES_TAB_SELECTED) {
    state = action.payload.key;
  }
  return state;
};

export const ManageChallengesList = (state = {}, action) => {
  switch (action.type) {
    case MANAGECHALLENGES_SINGE_LIST:
      return action.payload;
      break;
    case MANAGECHALLENGES_RECURRING_LIST:
      return action.payload;
      break;
    default:
      return state;
      break;
  }
};

export function LoadEditchallengesData(state = {}, action) {
  switch (action.type) {
    case LOAD_EDIT_CHALLENGES_DATA:
      return action.payload;
    default:
      return state;
  }
}

export function OpenChallengesPopup(state = [], action) {
  switch (action.type) {
    case OPEN_CHALLENGES_MODAL:
      return action.payload;
    default:
      return state;
  }
}

// Get max DISPLAYORDER number
export function GetMaxDisplayorder(state = [], action) {
  switch (action.type) {
    case MANAGECHALLENGES_MAX_DISPLAYORDER:
      return action.payload;
    default:
      return state;
  }
}

// Store Static HTML template data
export function getStaticTemplteHtml(state = [], action) {
  switch (action.type) {
    case MANAGECHALLENGES_HTML_TEMPLATE:
      return action.payload;
    default:
      return state;
  }
}
